import { render, staticRenderFns } from "./OnepersonStudentFilesJg.vue?vue&type=template&id=60aaf75f"
import script from "./OnepersonStudentFilesJg.vue?vue&type=script&lang=js"
export * from "./OnepersonStudentFilesJg.vue?vue&type=script&lang=js"
import style0 from "./OnepersonStudentFilesJg.vue?vue&type=style&index=0&id=60aaf75f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports